import { getEligibleBidderByEmail, updateEligibleBiddersWithUserUuid } from "./index";

async function checkAndUpdateBidder(email: string, user_uuid: string) {
    const bidders: any = await getEligibleBidderByEmail(email);
    const filteredBidders = bidders.filter((item: any) => !item.user_uuid);
    console.log("bidders", bidders, filteredBidders);
    for (let index = 0; index < filteredBidders.length; index++) {
        const element = filteredBidders[index];
        await updateEligibleBiddersWithUserUuid(element.uuid, user_uuid)
    }
}

export { checkAndUpdateBidder };
